import { render, staticRenderFns } from "./nestedFixed.vue?vue&type=template&id=4e7ff136&scoped=true"
import script from "./nestedFixed.vue?vue&type=script&lang=js"
export * from "./nestedFixed.vue?vue&type=script&lang=js"
import style0 from "./nestedFixed.vue?vue&type=style&index=0&id=4e7ff136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7ff136",
  null
  
)

export default component.exports